module.exports = __webpack_public_path__ + "static/media/card-lock-platinum.072e0fe8.svg";